import React, { useEffect, useState } from "react";
import ReactSelect from "react-select";
import { Card, Col, FormGroup, Row } from "reactstrap";
import ChartTrending from "./ChartTrending";
import CardTrendingContainer from "./CardTrendingContainer";
import { formatCurrency } from "helpers";
import ChartTrendingTrayek from "./ChartTrendingTrayek";
import moment from "moment";
import ChartTotalComodity from "./ChartTotalComodity";
import { useDispatch, useSelector } from "react-redux";
import { dashboardGetGlobalAll } from "actions/dashboardAction";
import LoadingGeneral from "views/Components/LoadingGeneral";
import { getDataList } from "actions/masterKodeTrayekAction";

const DashboardTrendContainer = () => {
  const dispatch = useDispatch();
  const [dataListChart, setDataListChart] = useState([]);
  const [kodeTrayek, setKodeTrayek] = useState("");
  const [kodeTrayekCont, setKodeTrayekCont] = useState("");
  const [yearCont, setYearCont] = useState("");
  const [yearTotalCom, setYearTotalCom] = useState("");
  const {
    dashboardGlobalGet,
    dashboardGlobalGetLoading,
    dashboardGlobalGetSuccess,
  } = useSelector((state) => state.dashboard);

  const dataT = useSelector((state) => {
    let result = state.kodeTrayek.getDataFilterTrayek;
    return result;
  });

  const getTrayek = (ruas = "") => {
    let dataTrayek = dataT.data
      ? dataT.data.reduce((allItem, item) => {
          let name = item.kode_trayek.split(" ");
          if (ruas === "") {
            let check = allItem.filter((f) => f.value === name[0]);
            if (check < 1) {
              allItem.push({
                value: name[0],
                label: name[0],
              });
            }
          } else {
            if (name[0] === ruas && name[1]) {
              let check = allItem.filter((f) => f.value === name[1]);
              if (check < 1) {
                allItem.push({
                  value: name[1],
                  label: name[1],
                });
              }
            }
          }
          return allItem;
        }, [])
      : [];
    return dataTrayek;
  };

  useEffect(() => {
    dispatch(dashboardGetGlobalAll());
    dispatch(getDataList());
  }, []);

  useEffect(() => {
    if (dashboardGlobalGetSuccess) {
      if (dashboardGlobalGet && dashboardGlobalGet.data) {
        setDataListChart(dashboardGlobalGet);
      }
    }
  }, [dashboardGlobalGetSuccess]);

  const handleShow = (e) => {
    setKodeTrayek(e);
  };

  const handleShowTrayek = (e) => {
    setKodeTrayekCont(e);
  };

  const handleShowYear = (e) => {
    setYearCont(e);
  };

  const handleShowTotalCom = (e) => {
    setYearTotalCom(e);
  };

  if (dashboardGlobalGetLoading) {
    return <LoadingGeneral />;
  }
  return (
    <div>
      <div className="rounded p-2 mb-4">
        <h5>
          <strong className="mb-2 ">
            Year To Year (YTY) Tahun{" "}
            {dataListChart.length !== 0 &&
              dataListChart.data.trend_container.length !== 0 &&
              `${dataListChart.data.trend_container[0].tahun_trayek} - ${
                dataListChart.data.trend_container[
                  dataListChart.data.trend_container.length - 1
                ].tahun_trayek
              }`}
          </strong>
        </h5>

        <div style={{ borderBottom: "2px solid blue", width: "10%" }} />
        {/* <FilterDashboard handleChangeYear={handleChangeYear} handleChangeMuatan={handleChangeMuatan} handleFilter={()=>handleFilter(0)}/> */}
      </div>

      <div className="d-flex flex-row">
        {dataListChart.length !== 0 &&
          dataListChart.data.trend_container.map((x, i) => (
            <React.Fragment key={i}>
              <CardTrendingContainer
                title={`AVG Container Monhtly ${x.tahun_trayek}`}
                amount={formatCurrency(x.average)}
                index={i}
                lastIndex={dataListChart.data.trend_container.length - 1}
              />
            </React.Fragment>
          ))}
      </div>

      <div className="d-flex flex-row">
        {dataListChart.length !== 0 &&
          dataListChart.data.trend_container.map((x, i) => (
            <React.Fragment key={i}>
              <CardTrendingContainer
                title={`Total Container ${x.tahun_trayek}`}
                amount={formatCurrency(x.total_container)}
                index={i}
                lastIndex={dataListChart.data.trend_container.length - 1}
              />
            </React.Fragment>
          ))}
      </div>

      {dataListChart.length !== 0 && (
        <Card>
          <Col>
            <ChartTrending dataChart={dataListChart} />
          </Col>
        </Card>
      )}

      {dataListChart.length !== 0 && (
        <div>
          <Row
            style={{ paddingLeft: "0px", paddingRight: "0px" }}
            className="mt-3"
          >
            <Col md="3">
              <FormGroup>
                <ReactSelect
                  name="trayek"
                  placeholder="Pilih Trayek..."
                  isClearable="true"
                  value={kodeTrayekCont}
                  onChange={handleShowTrayek}
                  options={getTrayek()}
                />
              </FormGroup>
            </Col>
            <Col md="3">
              <FormGroup>
                <ReactSelect
                  name="year"
                  placeholder="Pilih Tahun..."
                  isClearable="true"
                  value={yearCont}
                  onChange={handleShowYear}
                  options={dataListChart.data.trend_container.map((item) => {
                    return {
                      value: item.tahun_trayek,
                      label: item.tahun_trayek,
                    };
                  })}
                />
              </FormGroup>
            </Col>
          </Row>
          <Card>
            <ChartTrendingTrayek
              kodeTrayekCont={kodeTrayekCont}
              dataChart={dataListChart}
              yearCont={yearCont}
            />
          </Card>
        </div>
      )}

      {dataListChart.length !== 0 && (
        <div>
          <Row
            style={{ paddingLeft: "0px", paddingRight: "0px" }}
            className="mt-3"
          >
            <Col md="3">
              <FormGroup>
                <ReactSelect
                  name="trayek"
                  placeholder="Pilih Trayek..."
                  isClearable="true"
                  value={kodeTrayek}
                  onChange={handleShow}
                  options={getTrayek()}
                />
              </FormGroup>
            </Col>

            <Col md="3">
              <FormGroup>
                <ReactSelect
                  name="tahun"
                  placeholder="Pilih Tahun..."
                  isClearable="true"
                  value={yearTotalCom}
                  onChange={handleShowTotalCom}
                  options={dataListChart.data.trend_container.map((item) => {
                    return {
                      value: item.tahun_trayek,
                      label: item.tahun_trayek,
                    };
                  })}
                />
              </FormGroup>
            </Col>
          </Row>
          <Card className="mt-3">
            <div>
              <ChartTotalComodity
                dataChart={dataListChart}
                kodeTrayek={kodeTrayek}
                yearTotalCom={yearTotalCom}
              />
            </div>
          </Card>
        </div>
      )}
    </div>
  );
};

export default DashboardTrendContainer;
